'use client'

import { useEffect, useState } from 'react'
import { useTranslations, useLocale } from 'next-intl'
import { Button } from '@/components/ui/button'

export function CookieBanner() {
  const [visible, setVisible] = useState(false)
  const t = useTranslations('common.cookies')
  const locale = useLocale()

  useEffect(() => {
    if (!localStorage.getItem('cookie_consent')) {
      setVisible(true)
    }
  }, [])

  function accept() {
    localStorage.setItem('cookie_consent', 'accepted')
    setVisible(false)
    window.dispatchEvent(new Event('cookie_consent_accepted'))
  }

  function decline() {
    localStorage.setItem('cookie_consent', 'declined')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-4 right-4 z-50 w-80 bg-white rounded-2xl px-5 py-4 shadow-2xl border border-[var(--border)] flex flex-col gap-4">
      <p className="text-sm text-[var(--text-muted)]">
        {t('message')}{' '}
        <a href={`/${locale}/privacy-policy`} className="underline text-[var(--text-subtle)] hover:text-[var(--text-primary)] transition-colors">
          {t('learnMore')}
        </a>
      </p>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" onClick={decline} className="flex-1">
          {t('decline')}
        </Button>
        <Button size="sm" onClick={accept} className="flex-1">
          {t('accept')}
        </Button>
      </div>
    </div>
  )
}
